import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Header } from '@ftrprf/tailwind-components';
import useFormatMessage from 'hooks/useFormatMessage';
import { UserContext } from 'providers/UserProvider';
import URLS from 'utils/constants/urls';
import { dataTestIds } from 'utils/dataTestIds';
import { DemoSuperlightInfoBar } from '../DemoSuperlightInfoBar';

export function TeacherHeader() {
  const t = useFormatMessage();

  const user = useContext(UserContext);
  const { organization } = user;

  return (
    <>
      <Header organization={organization} user={user}>
        <NavLink to={URLS.ROOT}>{t('header.navigation.home')}</NavLink>
        <NavLink to={URLS.IT}>{t('demo.superlight.lesson.it')}</NavLink>
        <NavLink to={URLS.SCRATCH}>
          {t('demo.superlight.lesson.scratch')}
        </NavLink>
        <NavLink to={URLS.WIJS}>{t('demo.superlight.lesson.wijs')}</NavLink>
        <NavLink
          data-test={dataTestIds.header.userMenu.links.help}
          target="_blank"
          to={
            organization.language?.toLowerCase() === 'nl'
              ? process.env.REACT_APP_HELP_URL
              : process.env.REACT_APP_HELP_EN_URL
          }
        >
          {t('header.help_videos')}
        </NavLink>
      </Header>
      <DemoSuperlightInfoBar />
    </>
  );
}
